export const COMPLETE_SIGN_UP = 'COMPLETE_SIGN_UP';
export const SIGN_IN = 'SIGN_IN';
export const SIGN_OUT = 'SIGN_OUT';
export const RESTORE_TOKEN = 'RESTORE_TOKEN';
export const SIGNING_UP = 'SIGNING_UP';
export const VERIFYING_USER = 'VERIFYING_USER';
